import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  Row,
  Container,
  CardHeader,
  Col,
  CardBody,
  CardTitle,
  NavItem,
  TabContent,
  NavLink,
  Nav,
  CardText,
  Button,
  Table,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  TabPane,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Dropdown,
  CardFooter,
  UncontrolledTooltip,
} from "reactstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import tutorsModal from "models/tutors.modal";
import DeviceUUID from "device-uuid";
import { helper } from "lib/helper";
import SubAdminModal from "models/user.modal";
import moment from "moment";
import levelModal from "models/level.modal";
import ReferalModel from "models/referal.modal";
import { toast } from "lib/helper";
import { error } from "ajv/dist/vocabularies/applicator/dependencies";
import Loader from "components/loader/Loader";

const Referl = () => {
  const [Status, setStatus] = useState("Approved");
  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const parmas = useParams();
  const [indicate, setIndicate] = useState("All");

  const getListData = async () => {
    setIsLoading(true);

    // Use static data from ReferalModel
    const result = await ReferalModel.List();
    setIsLoading(false);
    if (result) {
      setDataList(result?.data);
      setCurrentPage(result?.meta?.current_page);
      setPerPage(result?.meta?.per_page);
    }
  };
  console.log("data list", dataList);
  useEffect(() => {
    getListData();
    golbaldata();
  }, []);

  const [alldata, setAlldata] = useState();
  const [pendingdata, setPendingdata] = useState();
  const [approveddata, setApproveddata] = useState();
  const [declinedata, setDeclineddata] = useState();

  const golbaldata = async () => {
    try {
      const allResult = await ReferalModel.List();
      setAlldata(allResult?.data?.length);

      const pendingResult = await ReferalModel.Listbystate("Pending");
      setPendingdata(pendingResult?.data?.length);

      const approvedResult = await ReferalModel.Listbystate("Approved");
      setApproveddata(approvedResult?.data?.length);

      const declinedResult = await ReferalModel.Listbystate("Declined");
      setDeclineddata(declinedResult?.data?.length);
    } catch (error) {
      console.log("error", error);
    }
  };

  const getListDataAccordingcondition = async (status) => {
    console.log("check status", status);
    setIsLoading(true);
    try {
      let result;
      if (status == "All") {
        result = await ReferalModel.List();
      } else {
        result = await ReferalModel.Listbystate(status);
      }
      setIsLoading(false);
      if (result) {
        setDataList(result?.data);
        golbaldata();
        setIndicate(status);
        setCurrentPage(result?.meta?.current_page);
        setPerPage(result?.meta?.per_page);
      }
    } catch (error) {
      setIsLoading(false);
      console.log("error", error);
    }
  };

  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  const handleDel = async (delId) => {
    helper.sweetalert
      .confirm("Are you sure you want to delete this Message", "info", true)
      .then((result) => {
        if (result.isConfirmed) {
          levelModal.removeLevel(delId).then((res) => {
            helper.sweetalert.toast(res.data?.message);
            getListData();
          });
        }
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
      });
  };
  const [item, setItem] = useState();

  const GetDetail = async (item) => {
    setItem(item?.id);
  };

  const Mark = async (event) => {
    event.preventDefault();
    const form = new FormData(event.target);
    console.log("item id", item);
    try {
      await ReferalModel.Mark(item, form);
      toggle();
      toast("Marked successfully", "success");
      getListData();
      golbaldata();
    } catch (error) {
      console.log("error", error);
    }
  };
  const [searchTerm, setSearchTerm] = useState("");
  const filteredDataList = dataList.filter((item) => {
    const fullName = String(item.name || "").toLowerCase();
    const mobile = String(item.mobile || "").toLowerCase();
    const status = String(item.status || "").toLowerCase();
    const search = searchTerm.toLowerCase();

    return (
      fullName.includes(search) ||
      mobile.includes(search) ||
      status.includes(search)
    );
  });
  return (
    <div className="pt-7 px-4 overflow-x-hidden">
      <Row>
        <div className="col">
          <Card className="shadow">
            <CardHeader className="border-0 d-flex justify-content-between ">
              <h3 className="mb-0">All Referral </h3>

              <div className="d-flex flex-row">
                {/* <i class="fa-solid fa-magnifying-glass"></i> */}
                <Input
                  className="mr-4"
                  type="text"
                  placeholder="Search"
                  size="sm"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </CardHeader>
            <div className="d-flex flex-row mb-2 pl-2">
              <span
                onClick={() => {
                  getListDataAccordingcondition("All");
                }}
                style={{
                  color: indicate == "All" ? "blue" : "black",
                  display: "flex",
                  marginLeft: "20px",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
              >
                All ({" "}
                <span
                  style={{
                    color: indicate == "All" ? "black" : "blue",
                  }}
                >
                  {alldata}
                </span>{" "}
                )
              </span>
              <span
                onClick={() => {
                  getListDataAccordingcondition("Pending");
                }}
                style={{
                  color: indicate == "Pending" ? "blue" : "black",
                  display: "flex",
                  marginLeft: "20px",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
              >
                Pending (
                <span
                  style={{
                    color: indicate == "Pending" ? "black" : "blue",
                  }}
                >
                  {pendingdata}
                </span>
                )
              </span>
              <span
                onClick={() => {
                  getListDataAccordingcondition("Approved");
                }}
                style={{
                  color: indicate == "Approved" ? "blue" : "black",
                  display: "flex",
                  marginLeft: "20px",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
              >
                Approved (
                <span
                  style={{
                    color: indicate == "Approved" ? "black" : "blue",
                  }}
                >
                  {approveddata}
                </span>
                )
              </span>
              <span
                onClick={() => {
                  getListDataAccordingcondition("Declined");
                }}
                style={{
                  color: indicate == "Declined" ? "blue" : "black",
                  display: "flex",
                  marginLeft: "20px",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
              >
                Declined (
                <span
                  style={{
                    color: indicate == "Declined" ? "black" : "blue",
                  }}
                >
                  {declinedata}
                </span>
                )
              </span>
            </div>
            <Table className="align-items-center table-flush" responsive>
              <thead className="thead-light">
                <tr>
                  <th scope="col">S. No.</th>
                  {/* <th scope="col">CLASS ID</th> */}
                  <th scope="col">Name (Mobile)</th>
                  <th scope="col">Refferal wallet</th>
                  <th scope="col">Refferel income</th>
                  <th scope="col">Invited referral </th>
                  <th scope="col">Request date </th>
                  <th scope="col">Request amount</th>
                  <th scope="col">Pay Amount </th>
                  <th scope="col">Pay date</th>
                  <th scope="col">Status</th>
                  <th scope="col">Screen Shot</th>
                  <th scope="col">Transaction id</th>
                  <th scope="col">Upi Id </th>
                  <th scope="col">Action</th>
                  {/* <th scope="col">Action</th> */}
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <tr>
                    <td
                      colSpan={12}
                      className="text-center align-middle w-full"
                    >
                      Please wait...
                      <Loader />
                    </td>
                  </tr>
                ) : filteredDataList.length > 0 ? (
                  filteredDataList?.length > 0 ? (
                    filteredDataList.map((item, index) => {
                      console.log("dta", item);
                      return (
                        <tr key={item.id} style={{ cursor: "pointer" }}>
                          <td>{(currentPage - 1) * perPage + index + 1}</td>
                          <td>
                            <div>
                              <div>{item?.name || "-"}</div>
                              <span style={{ color: "blue" }}>
                                ({item?.mobile})
                              </span>
                            </div>
                          </td>
                          <td>{item?.referral_wallet || "-"}</td>
                          <td>{item?.referral_income || "-"}</td>
                          <td>{item?.invited_referral || "-"}</td>
                          <td>{item?.request_date || "-"}</td>
                          <td>{item?.request_amount || "-"}</td>
                          <td>{item?.pay_amount || "-"}</td>
                          <td>{item?.pay_date || "-"}</td>
                          <td>{item?.status || "-"}</td>
                          <td>
                            {item?.screen_shot ? (
                              <img
                                src={`/images/${item.screen_shot}`}
                                alt="Screenshot"
                                style={{ width: "50px", height: "50px" }}
                                onClick={() => {
                                  const width = 600;
                                  const height = 400;
                                  const left =
                                    (window.screen.width - width) / 2;
                                  const top =
                                    (window.screen.height - height) / 2;
                                  window.open(
                                    `/images/${item.screen_shot}`,
                                    "_blank",
                                    `width=${width},height=${height},top=${top},left=${left}`
                                  );
                                }}
                              />
                            ) : (
                              "-"
                            )}
                          </td>
                          <td>{item?.transaction_id || "-"}</td>
                          <td>{item?.upi_id || "-"}</td>
                          <td
                            className="p-0"
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            {item?.status !== "Approved" && (
                              <>
                                <UncontrolledTooltip
                                  placement="top"
                                  target={`Markpaid${index}`}
                                >
                                  Mark
                                </UncontrolledTooltip>
                                <Link
                                  style={{
                                    margin: "0 5px",
                                    fontSize: "15px",
                                    color: "blue",
                                    alignItems: "center",
                                    display: "inline-block",
                                    marginTop: "23px",
                                    borderRadius: "30%",
                                  }}
                                  id={`Markpaid${index}`}
                                  onClick={() => {
                                    toggle();
                                    GetDetail(item);
                                  }}
                                >
                                  <i className="fa-solid fa-check"></i>
                                </Link>
                              </>
                            )}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td
                        colSpan="14"
                        style={{
                          textAlign: "center",
                          verticalAlign: "middle",
                          height: "100px",
                        }}
                      >
                        No data found
                      </td>
                    </tr>
                  )
                ) : (
                  <tr>
                    <td
                      colSpan="12"
                      style={{ textAlign: "center", padding: "1rem" }}
                    >
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            <CardFooter className="py-4">
              {/* <TablePagination
                totalPages={parseInt(dataList?.meta?.total_page)}
                currentPage={parseInt(dataList?.meta?.current_page)}
                pageUrl="/admin/messages?"
              /> */}
            </CardFooter>
          </Card>
        </div>
      </Row>

      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          <h4>Mark To/Declined/Approved</h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={Mark}>
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label for="exampleEmail">Request Amount</Label>
                  <Input
                    id="forType"
                    type="text"
                    disabled
                    defaultValue={item?.request_amount}
                    placeholder="Enter Request Amount"
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label for="exampleEmail">Approved / Declined</Label>
                  <Input
                    id="forType"
                    type="select"
                    name="status"
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    <option value="Approved">Approved</option>
                    <option value="Declined">Declined</option>
                  </Input>
                </FormGroup>
              </Col>
            </Row>
            {Status === "Approved" && (
              <>
                <Row>
                  <Col md={12}>
                    <FormGroup>
                      <Label for="exampleEmail">Payment Amount</Label>
                      <Input
                        id="forType"
                        type="text"
                        name="paid_amount"
                        placeholder="Enter Payment Amount"
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <FormGroup>
                      <Label for="exampleEmail">Screenshot</Label>
                      <Input
                        style={{
                          border: "1px solid lightgrey",
                          padding: "6px 10px",
                          borderRadius: "6px",
                        }}
                        name="screenshot"
                        id="forType"
                        type="file"
                        placeholder="Upload Screenshot"
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <FormGroup>
                      <Label for="exampleEmail">Transaction ID</Label>
                      <Input
                        id="forType"
                        type="text"
                        name="transaction_id"
                        placeholder="Enter Transaction ID"
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </>
            )}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggle}>
                Cancel
              </Button>
              <Button
                type="submit"
                style={{
                  backgroundColor: "#080278",
                  color: "white",
                  border: "none",
                }}
              >
                Save
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default Referl;
